import React from "react";
import "./review.tokens.scss";
import "./BookingCTA.scss";

/**
 * Presentational button for review flows. No navigation or API logic.
 *
 * @param {"primary"|"secondary"|"ghost"} [variant="primary"]
 * @param {string} [className]
 * @param {React.ReactNode} children
 * @param {object} [rest] native button props (onClick, disabled, type, etc.)
 */
export default function BookingCTA({ variant = "primary", className = "", children, ...rest }) {
  const v = variant === "secondary" ? "secondary" : variant === "ghost" ? "ghost" : "primary";
  return (
    <button
      type="button"
      className={`review-booking-cta review-booking-cta--${v}${className ? ` ${className}` : ""}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
